/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {familyAccountsUnlockIssuedCards} from '../api'

export const useMutationFamilyAccountsUnlockIssuedCards = createReactQueryMutationHook('familyAccountsUnlockIssuedCards', familyAccountsUnlockIssuedCards)
